import { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const WindPower = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ color = 'white', width = '25', height = '25', ...props }, ref) => {
    return (
      <SvgIcon
        ref={ref}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        sx={{
          backgroundColor: (theme) => theme.palette.badge3,
          borderRadius: 4,
          padding: '2px',
          width,
          height,
        }}
        {...props}
      >
        <g id="WindPowerRounded">
          <path
            d="M13.7902 11.3199C14.3563 11.4935 14.7715 11.9086 14.9753 12.4219L18.1984 7.05504C18.689 6.23982 18.4249 5.18306 17.6096 4.69242C16.9529 4.2999 16.1075 4.38293 15.5489 4.91132L12.9599 7.33433C12.6579 7.61362 12.4843 8.01368 12.4843 8.42884V11.3953C12.7561 11.2821 13.2241 11.1462 13.7902 11.3199Z"
            fill={color}
          />
          <path
            d="M11.4351 12.5729C11.5559 12.1803 11.7974 11.8482 12.1069 11.6142H5.90217C4.95108 11.6142 4.18115 12.3841 4.18115 13.3352C4.18115 14.1052 4.68689 14.777 5.42663 14.9883L8.83092 15.9621C9.23099 16.0753 9.66124 16.0224 10.0236 15.8035L12.0541 14.5883C11.4728 14.1203 11.2011 13.3277 11.4351 12.5729Z"
            fill={color}
          />
          <path
            d="M20.1912 17.3585L18.4701 14.2637C18.2663 13.9014 17.9191 13.6372 17.5191 13.5315L15.1187 12.9276C15.1413 13.1692 15.1187 13.4258 15.0432 13.6749C14.8017 14.475 14.077 15.011 13.2392 15.011C12.7787 15.011 12.4919 14.8449 12.4843 14.8449V19.1625C12.4843 19.6957 12.4843 19.8419 12.4843 20.6722H13.994C13.994 19.8419 13.994 19.8863 13.994 19.1625V15.9319L17.4738 19.4116C18.1456 20.0834 19.2325 20.0834 19.9043 19.4116C20.4478 18.8682 20.5686 18.0303 20.1912 17.3585Z"
            fill={color}
          />
          <path
            d="M12.907 14.2033C13.5033 14.3844 14.1374 14.0523 14.3185 13.4484C14.4997 12.8521 14.1676 12.2181 13.5637 12.0369C12.9674 11.8557 12.3333 12.1879 12.1521 12.7917C11.971 13.3881 12.3107 14.0221 12.907 14.2033Z"
            fill={color}
          />
        </g>
      </SvgIcon>
    );
  }
);

WindPower.displayName = 'WindPower';
